import { Table } from '@mantine/core';
import cx from 'clsx';
import { FC, memo, PropsWithChildren } from 'react';

import styles from './styles.module.css';

type Props = {
  children: React.ReactNode;
  fullWidth?: boolean;
};

export const Td: FC<PropsWithChildren<Props>> = memo(
  ({ children, fullWidth = false }) => (
    <Table.Td className={styles.td}>
      <div
        className={cx({
          [styles.content]: true,
          [styles.contentFullWidth]: fullWidth,
        })}
      >
        {children}
      </div>
    </Table.Td>
  )
);
